














































import VueOptions from '@utils/VueOptions'
import Gallery from '@ui/Gallery'

settings =
  name: 'CoolGallery'

  vue:
    props: ['photos']

    components: {
      Gallery,
    }

    data: ->
      currentIndex: 0
      galleryModal:
        show: false
        index: 0

    computed:
      filteredPhotos: ->
        @photos || []

      currentPhoto: ->
        @filteredPhotos[@currentIndex]

      photosForGalleryModal: ->
        @pluck(@filteredPhotos, 'url')

    methods:
      hiSelectPhoto: (index) ->
        @currentIndex = index

      hiPreviousPhoto: ->
        @currentIndex = if @currentIndex > 0 then @currentIndex - 1 else @filteredPhotos.length - 1

      hiNextPhoto: ->
        @currentIndex = if @currentIndex < @filteredPhotos.length - 1 then @currentIndex + 1 else 0

      hiPreviewPhoto: (index) ->
        @galleryModal.index = index
        @galleryModal.show = true

    watch:
      photos: ->
        @currentIndex = 0

export default VueOptions.vue settings
